export { default } from './ShortText';
